// extracted by mini-css-extract-plugin
export default {"label":"label--_koKW","content":"content--_SY3d"};